"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createControllerContext = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = (0, tslib_1.__importStar)(require("react"));
const createControllerContextHocs_1 = require("./createControllerContextHocs");
const compose_1 = require("./compose");
const setDisplayName_1 = (0, tslib_1.__importDefault)(require("./setDisplayName"));
const createControllerContext = (ControllerCls, ...propInjectors) => {
    const Context = React.createContext(null);
    class ControllerProvider extends React.Component {
        constructor(props) {
            super(props);
            this.controller = new ControllerCls(this.state, this.props, this.setState.bind(this));
            this.state = this.controller.defaultState || {};
            this.controller.state = this.state;
        }
        componentDidUpdate() {
            this.controller.state = this.state;
            this.controller.props = this.props;
        }
        componentDidMount() {
            this.controller.componentDidMount();
        }
        componentWillUnmount() {
            this.controller.componentWillUnMount();
        }
        render() {
            return ((0, jsx_runtime_1.jsx)(Context.Provider, Object.assign({ value: {
                    controller: this.controller,
                    state: this.state,
                    props: this.props,
                } }, { children: this.props.children }), void 0));
        }
    }
    const Provider = (0, compose_1.compose)(...propInjectors, (0, setDisplayName_1.default)(`${ControllerCls.name}Provider`))(ControllerProvider);
    const Consumer = (0, setDisplayName_1.default)(`${ControllerCls.name}Consumer`)(Context.Consumer);
    return Object.assign({ Provider,
        Consumer }, (0, createControllerContextHocs_1.createControllerContextHocs)(Provider, Consumer));
};
exports.createControllerContext = createControllerContext;
//# sourceMappingURL=createControllerContext.js.map